import { notifyWindowCapReached, windowStack } from "@/app/windowStack";

export const diagnosticJobsChangedEvent = "hatchery:diagnostic-jobs-changed";

export function openDiagnosticSubmitWindow(): void {
  const id = windowStack.open({
    kind: "diagnosticSubmit",
    key: "new",
    title: "진단 작업 추가",
    params: {},
  });
  if (id === null) notifyWindowCapReached();
}
